import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { buttonVariants } from "@react/shared/ui/Button"
import { useDropdownMenu, MenuPanel, MENU_ITEM } from "@react/shared/ui/DropdownMenu"

const MENU_WIDTH = 240

const FooterActionsMenu = ({ items }) => {
  const { open, close, toggle, pos, btnRef, menuRef } = useDropdownMenu({ width: MENU_WIDTH, align: "right" })
  const shown = items.filter(Boolean)

  const run = item => () => {
    close()
    item.onClick()
  }

  if (shown.length === 0) return null

  return (
    <>
      <button
        ref       = {btnRef}
        type      = "button"
        onClick   = {toggle}
        className = {`${buttonVariants({ variant: "ghost", size: "sm" })} whitespace-nowrap ${open ? "bg-slate-100 text-slate-900" : ""}`}
      >
        {I18n.t("quotes.builder.row_menu.actions")}
        <FontAwesomeIcon icon="chevron-down" className="w-2.5 h-2.5 opacity-60" />
      </button>

      {open && (
        <MenuPanel menuRef={menuRef} pos={pos} width={MENU_WIDTH}>
          {shown.map(entry => (
            <button
              key      = {entry.key}
              type     = "button"
              className= {MENU_ITEM}
              disabled = {!!entry.disabled}
              title    = {entry.title || ""}
              onClick  = {run(entry)}
            >
              <FontAwesomeIcon icon={entry.busy ? "spinner" : entry.icon} spin={!!entry.busy} />
              {entry.label}
            </button>
          ))}
        </MenuPanel>
      )}
    </>
  )
}

export default FooterActionsMenu
